const allowRoles = ['SUPER', 'MOVEPRO_ADMIN', 'DEVELOPER', 'OWNER', 'ADMIN'];

export default [
    {
        path: '/migrated-data',
        name: 'MigratedDataIndex',
        meta: {
            requiresAuth: true,
            allowRoles,
            denyRoles: null,
            title: 'Migrated data',
        },
        components: {
            default: () => import('@views/migrated-data/MigratedDataIndex.vue'),
        },
    },
];
